<mat-toolbar color="primary" class="w-full">
  <div class="w-full">
    <img src="assets\Bizi logo-white letters.png" class="logo-img" />
  </div>

  <div class="justify-items-center content-center">
    <div class="hidden sm:flex">
      <button mat-button routerLink="/home">Home</button>
      <button mat-button routerLink="/admins">Admins</button>
      <button mat-button routerLink="/vendors">Vendors</button>
      <button mat-button routerLink="/users">Users</button>
      <button mat-button routerLink="/posts">Posts</button>
      <button mat-button routerLink="/colleges">Colleges</button>
      <button mat-button routerLink="/campuses">Campuses</button>
      <button mat-button routerLink="/all-listings">All Listings</button>
    </div>

    <div class="block sm:hidden">
      <button mat-button [mat-menu-trigger-for]="routes" class="flex flex-row">
        {{ pageName }}
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
      <mat-menu #routes>
        <button
          mat-menu-item
          *ngFor="let link of links"
          (click)="routeClick(link.label, link.route)"
        >
          {{ link.label }}
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="flex justify-end w-full">
    <p class="sm:flex items-center invisible sm:visible hidden">
      {{ adminName }}
    </p>

    <button class="logo-img" mat-button [mat-menu-trigger-for]="userInfo">
      <img [src]="getAvatarUrl()" />
    </button>
    <mat-menu #userInfo>
      <button mat-menu-item routerLink="/account-info">
        <mat-icon>account_circle</mat-icon>
        <span> Account </span>
      </button>
      <button mat-menu-item (click)="logout()">
        <mat-icon> exit_to_app </mat-icon>
        <span>Log Out</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
